import BRecipeList from "./BRecipeList";

const DEBOUNCE_MS = 400;
const MIN_QUERY_LENGTH = 2;

function getQuery(input) {
    return input.value.trim();
}

function triggerSearch(input) {
    const list = input.closest("[data-list]");
    if (!list) {
        return;
    }

    const query = getQuery(input);
    if (query.length > 0 && query.length < MIN_QUERY_LENGTH) {
        return;
    }

    BRecipeList.setQuery(list, query);
    BRecipeList.reload(list);
}

export default {
    initialize() {
        document.querySelectorAll(".rcp-filter input[name=\"query\"]").forEach((input) => {
            let debounceTimer = null;

            input.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    clearTimeout(debounceTimer);
                    triggerSearch(input);
                }
            });

            input.addEventListener("input", (event) => {
                clearTimeout(debounceTimer);

                if (event.inputType === "insertFromPaste") {
                    triggerSearch(input);
                    return;
                }

                debounceTimer = setTimeout(() => triggerSearch(input), DEBOUNCE_MS);
            });

            const searchBtn = input.closest(".search")?.querySelector(".btn");
            if (searchBtn) {
                searchBtn.style.cursor = "pointer";
                searchBtn.addEventListener("click", () => {
                    clearTimeout(debounceTimer);
                    triggerSearch(input);
                });
            }

            document.addEventListener("keydown", (event) => {
                if (event.key === "/" && event.shiftKey) {
                    const tag = document.activeElement?.tagName;
                    if (tag === "INPUT" || tag === "TEXTAREA" || document.activeElement?.isContentEditable) {
                        return;
                    }
                    event.preventDefault();
                    input.focus();
                    input.select();
                }
            });
        });
    },
};
